// extracted by mini-css-extract-plugin
export default {"card":"components-settings-pms-integration-seasonal-strategy-card-module__card"};